var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "actions-container"
  }, [_c('div', {
    staticClass: "text-format-button",
    class: _vm.options.isBoldDisabled ? 'disabled' : ''
  }, [_c('svg', {
    attrs: {
      "height": "50",
      "width": "50"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.svg.boldSvg)
    },
    on: {
      "click": function ($event) {
        return _vm.handleAction('bold');
      }
    }
  })]), _c('div', {
    staticClass: "text-format-button",
    class: _vm.options.isItalicDisabled ? 'disabled' : ''
  }, [_c('svg', {
    attrs: {
      "height": "50",
      "width": "50"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.svg.italicSvg)
    },
    on: {
      "click": function ($event) {
        return _vm.handleAction('italic');
      }
    }
  })]), _c('div', {
    staticClass: "text-format-button",
    class: _vm.options.isUnderlineDisabled ? 'disabled' : ''
  }, [_c('svg', {
    attrs: {
      "height": "50",
      "width": "50"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.svg.underlineSvg)
    },
    on: {
      "click": function ($event) {
        return _vm.handleAction('underline');
      }
    }
  })])]);
}
var staticRenderFns = []

export { render, staticRenderFns }